import script from "./TravellerForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./TravellerForm.vue?vue&type=script&lang=ts&setup=true"

import "./TravellerForm.vue?vue&type=style&index=0&id=6c0b204f&lang=scss&scoped=true"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c0b204f"]])

export default __exports__